import React, { useState, useEffect, useReducer } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { PHONE_STATUS_ACTIVE, PHONE_STATUS_INACTIVE } from '../../../constants/UiBuilderConst';

const PhoneSelector = (props) => {
  const { onValueChange, value, onPhoneStatusChange, isActive, error, maxLength } = props;

  const [statusValue, setStatusValue] = useState(
    isActive ? PHONE_STATUS_ACTIVE : PHONE_STATUS_INACTIVE,
  );

  useEffect(() => {
    setStatusValue(isActive ? PHONE_STATUS_ACTIVE : PHONE_STATUS_INACTIVE);
  }, [isActive]);

  useEffect(() => {
    onPhoneStatusChange(statusValue === PHONE_STATUS_ACTIVE);
  }, [statusValue]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    phone: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    const currFields = { ...formData };
    currFields.phone.value = value;
    formData.phone.validations = isActive ? ['required'] : [];
    currFields.phone.errors = error
      ? { required: `${currFields.phone.fieldName} is required` }
      : {};
    setFormData(currFields);
  }, [value, error]);

  useEffect(() => {
    onValueChange(formData.phone.value);
  }, [formData.phone.value]);

  const onStatusChange = (e) => {
    formData.phone.validations = e.target.value === PHONE_STATUS_ACTIVE ? ['required'] : [];
    setStatusValue(e.target.value);
    const phone = { ...formData.phone };
    phone.validations = e.target.value === PHONE_STATUS_ACTIVE ? ['required'] : [];
    setFormData({ phone });
  };

  return (
    <>
      <div className='col-md-12 redirect-selector mb-3'>
        <div className='row align-items-center mb-2 mt-3'>
          <div className='col-md-4 title'>Phone</div>
          <div className='col-md-8'>
            <RadioGroup
              row
              aria-label='statusValue'
              onChange={onStatusChange}
              value={statusValue}
              className='document-type'
              name='row-radio-buttons-group'
            >
              <FormControlLabel
                value={PHONE_STATUS_ACTIVE}
                control={<Radio color='primary' />}
                label='Active'
                className='me-5'
              />
              <FormControlLabel
                value={PHONE_STATUS_INACTIVE}
                control={<Radio color='primary' />}
                label='Inactive'
              />
            </RadioGroup>
          </div>
        </div>
        {statusValue === PHONE_STATUS_ACTIVE && (
          <div className='col-md-10'>
            <CustomTextField
              item={formData.phone}
              handleInputChange={(e) => {
                setFormData({ phone: e });
              }}
              maxLength={maxLength}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PhoneSelector;
